import {
    AccordionDetails,
    AccordionSummary,
    Box,
    Chip,
    Stack,
} from "@mui/material"
import Divider from "@mui/material/Divider"
import {ChevronDown} from "lucide-react"
import React from "react"
import {iconMap} from "../../../../src/assets/icons"
import InfoIcon from "../../../components/general/infoIcon"

const AccordionBase = ({
                           Wrapper,
                           Title,
                           Subtitle,
                           variant,
                           expanded,
                           onChange,
                           disabled,
                           disableGutters,
                           text,
                           subtext,
                           badge,
                           children,
                           infotext,
                       }) => (
    <Wrapper
        variant={variant}
        expanded={expanded}
        onChange={onChange}
        disabled={disabled}
        disableGutters={disableGutters}>
        <AccordionSummary expandIcon={<ChevronDown/>}>
            <Box
                sx={{
                    display: "flex", alignItems: "center", gap: 1.5, width: "100%", pt: "5px", pb: "5px"
                }}>
                {expanded ? iconMap["Info"] : iconMap["CircleCheck"]}
                <Stack sx={{flex: 1}}>
                    <Title variant={variant}>{text}</Title>
                    {subtext && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Subtitle variant={variant}>{subtext}</Subtitle>
                            {infotext && <InfoIcon infoText={infotext} />}
                        </Box>
                    )}
                </Stack>
                {badge && (
                    <Chip
                        label={badge}
                        size="small"
                        color="success"
                        variant="outlined"
                        sx={{mr: 2}}
                    />
                )}
            </Box>
        </AccordionSummary>
        <Divider/>
        <AccordionDetails>{children}</AccordionDetails>
    </Wrapper>
)

export default AccordionBase
